import api from './client.js'

export const playersAPI = {
  list: (q) => api.get('/players', { params: q ? { q } : undefined }),
  get:  (userId) => api.get(`/players/${userId}`),
  setTrophyVisibility: (key, hidden) =>
    api.patch(`/players/me/trophies/${encodeURIComponent(key)}/visibility`, { hidden }),
  reorderTrophies: (order) => api.post('/players/me/trophies/reorder', { order }),
}
